{
  "version": 1,
  "asset_id": "453547f2-6572-4490-a78a-bae68c136c32",
  "project_id": "8d7278d8-f7c2-487a-a967-889b9bac3b6c",
  "url": "/__l5e/assets-v1/453547f2-6572-4490-a78a-bae68c136c32/free-vending-machines-for-workplaces-businesses.avif",
  "r2_key": "a/v1/8d7278d8-f7c2-487a-a967-889b9bac3b6c/453547f2-6572-4490-a78a-bae68c136c32/free-vending-machines-for-workplaces-businesses.avif",
  "original_filename": "free-vending-machines-for-workplaces-businesses.avif",
  "size": 40053,
  "content_type": "image/avif",
  "created_at": "2026-07-03T06:50:56Z"
}
